import Flickity from 'flickity';

export default(() => {
    const carousels = Array.from(document.querySelectorAll('.js-datasheet'));

    carousels.forEach((carousel) => {
        const flkty = new Flickity(carousel, {
            cellSelector: '.datasheet__slide',
            cellAlign: 'left',
            prevNextButtons: false,
            pageDots: false,
            wrapAround: true,
        });

        const parent = carousel.closest('.datasheet');
        const prevButton = parent.querySelector('.news__pagination-prev');
        const nextButton = parent.querySelector('.news__pagination-next');

        if (prevButton) {
            prevButton.addEventListener('click', () => {
                flkty.previous();
            });
        }

        if (nextButton) {
            nextButton.addEventListener('click', () => {
                flkty.next();
            });
        }

        if (flkty.slides.length < 2) {
            prevButton.style.display = 'none';
            nextButton.style.display = 'none';
        }
    });
})();
